/**
 * Token del cliente identificado (2.9, G157, ADR-0058): el `access_token` de `confirmCustomerCode` (esquema `customer`,
 * 30 minutos sin renovación). Vive en sessionStorage con su propia clave, **nunca** junto a la sesión del equipo
 * (`sesion/sesion.ts`) ni a la de la tablet: se pierde al cerrar la pestaña y no sirve en el panel.
 */
export interface SesionCliente {
    token: string;
    /** Fin del token (`expires_at`); pasado, se olvida sin llamar a la API. */
    caduca: string;
}

export interface AlmacenCliente {
    actual: () => SesionCliente | null;
    guardar: (s: SesionCliente | null) => void;
}

export const CLAVE_TOKEN_CLIENTE = 'reservaria.cliente.token';

type Almacen = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function almacenDeSesion(): Almacen | null {
    try {
        return typeof window === 'undefined' ? null : window.sessionStorage;
    } catch {
        return null;
    }
}

const esSesion = (v: unknown): v is SesionCliente =>
    typeof v === 'object' && v !== null && typeof (v as Record<string, unknown>).token === 'string' && typeof (v as Record<string, unknown>).caduca === 'string';

export function crearAlmacenCliente(almacen: Almacen | null = almacenDeSesion(), ahora: () => number = Date.now): AlmacenCliente {
    let sesion: SesionCliente | null = null;
    try {
        const v: unknown = JSON.parse(almacen?.getItem(CLAVE_TOKEN_CLIENTE) ?? 'null');
        sesion = esSesion(v) ? v : null;
    } catch {
        sesion = null;
    }
    const guardar = (s: SesionCliente | null) => {
        sesion = s;
        try {
            if (s === null) {
                almacen?.removeItem(CLAVE_TOKEN_CLIENTE);
            } else {
                almacen?.setItem(CLAVE_TOKEN_CLIENTE, JSON.stringify(s));
            }
        } catch {
            // Sin almacenamiento: vive solo en memoria.
        }
    };
    return {
        actual: () => {
            if (sesion !== null && Date.parse(sesion.caduca) <= ahora()) {
                guardar(null);
            }
            return sesion;
        },
        guardar,
    };
}
